import { Education } from '../types';
import { escapeHtml } from '../utils/security';
import { sectionHeader } from './common';

export function buildEducation(education: Education) {
    const root = document.querySelector('[data-section="education"]');
    if (!root) return;

    const itemsHtml = education.items.map(item => `
        <div class="flex gap-5 bg-white border border-n100 rounded-lg p-7 shadow-sm animate-fadeUp">
            <div class="w-[52px] h-[52px] flex-shrink-0 rounded-md bg-creme border border-n100 flex items-center justify-center text-graphite">
                <i data-lucide="${escapeHtml(item.icon)}" stroke-width="1.5" class="w-6 h-6"></i>
            </div>
            <div>
                <h3 class="text-lg leading-[1.35] font-semibold text-graphite mb-1.5">${escapeHtml(item.degree)}</h3>
                <div class="text-[15px] font-semibold text-sunset-dark mb-1.5">${escapeHtml(item.institution)}</div>
                <div class="font-mono text-[13px] text-n400">${escapeHtml(item.period)}</div>
                ${item.notes ? `<p class="text-sm text-n500 mt-2">${escapeHtml(item.notes)}</p>` : ''}
            </div>
        </div>
    `).join('');

    root.innerHTML = `
        ${sectionHeader(education.kicker, education.heading)}
        <div class="grid md:grid-cols-2 gap-6">
            ${itemsHtml}
        </div>
    `;
}
